<template>
  <ProviderDetails />
</template>

<script>
import ProviderDetails from '@/modules/provider/provider-details/ProviderDetails.vue'

export default {
  components: { ProviderDetails },
}
</script>
